// AddBaseButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './AddBaseButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * AddBaseButton
 * 
 * Renders a button that allows the user to add a space.
 * 
 * @param {function} onClick - The function to call when the button is clicked.
 * @param {string} label - The text label to display on the button (default: 'Add Space').
 * @param {string} iconKey - The key for the icon to display (default: 'add').
 *  
 *
 * @returns {ReactNode} - AddBaseButton.
 */
const AddBaseButton = React.memo(({ onClick, label = 'New Workspace', iconKey = 'add' }) => {

    // ----- CONTEXT ----- //

    // Theme Context

    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State

    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div
          className="add-base-button-container"
          style={{
                backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
            }}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >

            <Icon
              iconKey={iconKey}
              color={theme.foreground}
              width={18}
              height={18}
            />

            {/* ADD SPACE TEXT */}
            <div
              className="add-base-button-text"
              style={{
                    color: hovered ? theme.buttonHoverLabelColor : theme.foreground,
                }}
            > 
                {label}
            </div>

        </div>
    );

});

// Dev Tools
AddBaseButton.displayName = 'AddBaseButton';

export default AddBaseButton;
